
/**
 * Abstract base class for tracking providers.
 * All tracking providers should extend this class and implement its methods.
 */
class TrackingProvider {
  constructor(config = {}) {
    this.config = config;
    this.name = 'AbstractProvider';
  }

  /**
   * Initialize the provider with configuration.
   */
  init() {
    throw new Error('Method not implemented: init');
  }

  /**
   * Track an event.
   * @param {string} eventName - The name of the event.
   * @param {object} properties - Additional properties for the event.
   */
  track(eventName, properties) {
    throw new Error('Method not implemented: track');
  }

  /**
   * Identify the user.
   * @param {string} userId - The unique identifier for the user.
   * @param {object} traits - User traits/properties.
   */
  identify(userId, traits) {
    throw new Error('Method not implemented: identify');
  }

  /**
   * Track a page view.
   * @param {string} path - The path of the page.
   * @param {object} properties - Additional properties for the page view.
   */
  page(path, properties) {
    throw new Error('Method not implemented: page');
  }
}

export default TrackingProvider;
